import SwitchMachineSlider from './SwitchMachineSlider'
export default SwitchMachineSlider
